export enum ScannerRoutePathNames {
  SCANNER = 'scanner',
}
